<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/shopping-center/complexe_desjardins.png" bg>
            Complexe Desjardins
        </client-card>
        <client-card src="img/clients-color/shopping-center/place-rosemere.png">
            Place Rosemère
        </client-card>
        <client-card src="img/clients-color/shopping-center/new-sudbury-centre.png">
            New Sudbury Centre
        </client-card>
        <client-card src="img/clients-color/shopping-center/promenade_cathedrale.png">
            Promenades Cathédrale
        </client-card>
        <client-card src="img/clients-color/shopping-center/carrefour_angrignon.png">
            Carrefour Angrignon
        </client-card>
        <client-card src="img/clients-color/shopping-center/carrefour_nord.png">
            Carrefour du Nord
        </client-card>
        <client-card src="img/clients-color/shopping-center/centropolis.png">
            Centropolis
        </client-card>
        <client-card src="img/clients-color/shopping-center/mail_montenach.png">
            Mail Montenach
        </client-card>
        <client-card src="img/clients-color/shopping-center/bayshore.png">
            Bayshore
        </client-card>
        <client-card src="img/clients-color/shopping-center/centre_eaton.png">
            Centre Eaton de Montréal
        </client-card>
        <client-card src="img/clients-color/shopping-center/alexis_nihon.png">
            Alexis Nihon
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-shopping-mall-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Shopping Mall client guest wifi|Client centre commercial wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
